import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { RootState } from '@cp/src/store';
import { LoadingIcon } from '@navi/web-ui/lib/icons';
import { Button, ModalDialog, Typography } from '@navi/web-ui/lib/primitives';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import CustomerDetail from '../../CsaTicketing/components/CustomerDetail';
import TicketForm from '../../CsaTicketing/components/TicketForm';
import { updateTicketStatus } from '../actions/CsaCoordintationActions';
import { setTasksForMe } from '../reducers/CsaCoordinationSlice';
import { ICloseTicketModal } from '../types';

const CloseTicketModal = (props: ICloseTicketModal) => {
  const { toggleCloseTicketModal, status } = props;
  const tickets = useSelector((state: RootState) => state?.csaCoordination?.tasksForMe);
  const ticket = useSelector((state: RootState) => state?.csaTicketing?.ticket?.ticketDetails);
  const isLoading = useSelector((state: RootState) => state?.csaTicketing?.ticket?.isLoading);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    watch,
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors }
  } = useForm<any>({
    mode: 'onChange'
  });

  const formValues = getValues('componentAdjustments');

  const dispatch = useDispatch();
  const handleTicketCloseFormSubmit = () => {
    const { referenceId } = ticket || {};
    const payload = {
      status,
      comment: formValues?.comment,
      address: formValues?.address ?? '',
      ticketReferenceId: referenceId
    };
    setIsSubmitting(true);
    addClickstreamEvent(CLICKSTREAM_EVENT_NAMES.LH_TASK_MARKED_DONE_BUTTON_CLICKED, {
      ticketId: referenceId
    });
    updateTicketStatus({
      payload,
      successCallbackFn: () => {
        const { data = [] } = tickets || {};
        const ticketsData = [...data];
        const ticketIndex = ticketsData?.findIndex(
          ticketData => ticketData?.referenceId === referenceId
        );
        if (ticketIndex !== -1) {
          ticketsData[ticketIndex] = {
            ...ticketsData[ticketIndex],
            status: status
          };
          dispatch(
            setTasksForMe({
              ...tickets,
              data: ticketsData
            })
          );
        }
        toggleCloseTicketModal();
      },
      finallyCallBackFn: () => setIsSubmitting(false)
    });
  };

  return (
    <ModalDialog
      contentClasses="!mt-4 !mb-8"
      customFooter={
        <div className="flex gap-4 justify-end">
          <Button onClick={toggleCloseTicketModal} variant="secondary" disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleSubmit(handleTicketCloseFormSubmit)} className="min-w-[112px]">
            {isSubmitting ? <LoadingIcon color="white" /> : 'Mark as done'}
          </Button>
        </div>
      }
      open={true}
      header="Mark task as done"
      onClose={toggleCloseTicketModal}
    >
      <SuspenseLoader
        loading={isLoading}
        fallBack={
          <LineLoader
            containerStyle="mb-2"
            numberOfLines={1}
            childrenType="H5"
            lineStyle="w-[50%] h-[20px]"
          />
        }
      >
        <Typography variant="h5" color="var(--navi-color-gray-c3)" className="mb-2">
          {ticket?.requestTypeLabel}
        </Typography>
      </SuspenseLoader>

      <CustomerDetail ticket={ticket} loading={isLoading} hideTicketStatus containerClass="m-0" />
      <form>
        <TicketForm
          watch={watch}
          setValue={setValue}
          getValues={getValues}
          register={register}
          errors={errors}
          commentValidation={{ required: 'Leave a comment to mark as done' }}
        />
      </form>
    </ModalDialog>
  );
};

export default CloseTicketModal;
